import { render } from "./TRTBoardColumn.vue?vue&type=template&id=e7e6643a&scoped=true"
import script from "./TRTBoardColumn.vue?vue&type=script&lang=js"
export * from "./TRTBoardColumn.vue?vue&type=script&lang=js"

import "./TRTBoardColumn.vue?vue&type=style&index=0&id=e7e6643a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e6643a"]])

export default __exports__